import withStartUpApp from '@/bootstarp/startup';
import Layout from '@/components/layout/Layout.vue';
import createRouter from '@/router';

withStartUpApp(Layout, {
  preloadImages: ['/topiclist/banner.png'],
  beforeMount(app) {
    createRouter(app, [
      {
        path: '/',
        component: () => import('@/pages/special/specialList.vue'),
      },
    ]);
  },
});
